import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Locale from "@/locale";
import DashboardView from "@/views/user/DashboardView.vue";
import ElectionVotingView from "@/views/election/ElectionVotingView.vue";
import ElectionBallotView from "@/views/election/ElectionBallotView.vue";
import ElectionStartView from "@/views/election/ElectionStartView.vue";
import ErrorView from "@/views/ErrorView.vue";
import ForgotPasswordView from "../views/forgot-password/ForgotPasswordView.vue";
import LoginView from "@/views/LoginView.vue";
import RegisterView from "@/views/registration/RegisterView.vue";
import RegisterValidateView from "@/views/registration/RegisterValidateView.vue";
import RegistrationSuccess from "@/views/registration/RegistrationSuccess.vue";
import SettingsView from "@/views/user/SettingsViewV2.vue";
import UpdatePasswordView from "@/views/forgot-password/UpdatePasswordView.vue";
import UserProfileView from "@/views/user/UserProfileView.vue";
import PrivacyPolicyView from "@/views/static/PrivacyPolicyView.vue";
import TermsOfUserView from "@/views/static/TermsView.vue";
import AboutUsView from "@/views/static/AboutUsView.vue";
import VueCookies from 'vue-cookies';
import ServicesView from "@/views/user/ServicesView.vue";
import EFTView from "@/views/services/EFTView.vue";
// import EventsView from "@/views/events/EventsView.vue";
// import store from "@/store";


const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    meta: {
      title:"Login",
      auth: false,
      passive: false,
    },
    component: LoginView,
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    meta: {
      title: Locale.get("Forgot Password"),
      auth: false,
      passive: false,
    },
    component: ForgotPasswordView,
  },
  {
    path: "/forgot-password/update",
    name: "update-password",
    meta: {
      title: 'Update Password',
      auth: false,
      passive: false,
    },
    component: UpdatePasswordView,
  },
  {
    path: "/register",
    name: "register",
    meta: {
      title: Locale.get('Register'),
      auth: false,
      passive: false,
    },
    component: RegisterView,
  },
  {
    path: "/register/validate",
    name: "register-validate",
    meta: {
      title: 'Validate OTP',
      auth: false,
      passive: false,
    },
    component: RegisterValidateView,
  },
  {
    path: "/register/success",
    name: "register-success",
    meta: {
      title: Locale.get('Register'),
      auth: false,
      passive: false,
    },
    component: RegistrationSuccess,
  },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    meta: {
      title: Locale.get("Privacy Policy"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: PrivacyPolicyView,
  },
  {
    path: "/about-us",
    name: "about-us",
    meta: {
      title: Locale.get("About Us"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: AboutUsView,
  },
  {
    path: "/terms-of-use",
    name: "terms-of-use",
    meta: {
      title: Locale.get("Terms of Use"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: TermsOfUserView,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: Locale.get("Dashboard"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: DashboardView,
  },
  {
    path: "/services",
    name: "services",
    meta: {
      title: Locale.get("Services"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: ServicesView,
  },
  // {
  //   path: "/events",
  //   name: "events",
  //   meta: {
  //     title: Locale.get("Events"),
  //     auth: true,
  //     passive: true,
  //     navbar:true,
  //   },
  //   component: EventsView,
  // },
  {
    path: "/services/EFT",
    name: "eft",
    meta: {
      title: Locale.get("Electronic Fund Transfer"),
      auth: true,
      passive: true,
      navbar:true,
    },
    component: EFTView,
  },
  {
    path: "/election/start",
    name: "election-start",
    meta: {
      title: 'Voter OTP',
      auth: true,
      passive: false,
      navbar: false,
    },
    component: ElectionStartView,
  },
  {
    path: "/election/ballot",
    name: "election-ballot",
    meta: {
      title: 'Election Ballot',
      auth: true,
      passive: false,
      navbar: true,
    },
    component:ElectionBallotView
    ,
  },
  {
    path: "/election/voting",
    name: "election-voting",
    meta: {
      title: 'Voting Screen',
      auth: true,
      passive: false,
      navbar: false,
    },
    component: ElectionVotingView,
  },
  {
    path: "/user/settings",
    name: "settings",
    meta: {
      title: Locale.get('Settings'),
      auth: true,
      passive: true,
      navbar:true
    },
    component: SettingsView,
  },
  {
    path: "/user/profile",
    name: "profile",
    meta: {
      title: "User Profile",
      auth: true,
      passive: false,
    },
    component: UserProfileView,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "error",
    meta: {
      title: Locale.get('404 Page Not Found'),
      auth: false,
      passive: true,
    },
    component: ErrorView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
});

const cookies = VueCookies as any;

router.beforeEach((to, from, next) => {
  const title = to.meta.title as any;
  document.title = title?.toString();

  const session = cookies.get("user_session");
  const hasHash = !!session?.hash;

  // Define routes that can be accessed without login
  const publicPages = ["/", "/forgot-password", "/forgot-password/update", "/register", "/register/validate", "/register/success", "/privacy-policy", "/about-us", "/terms-of-use", "/:pathMatch(.*)*"];

  const isPublicPage = publicPages.includes(to.path);

  // Redirect unauthenticated users trying to access protected pages
  if (!hasHash && !isPublicPage) {
    return next("/");
  }

  // Redirect authenticated users away from the login or signup pages
  if (hasHash && ["/", "/forgot-password", "/forgot-password/update", "/register", "/register/validate", "/register/success", "/privacy-policy", "/about-us", "/terms-of-use", "/:pathMatch(.*)*"].includes(to.path)) {
    return next("/dashboard");
  }

  return next();
});

export default router;
